export const T = {
  en_GB: { open: "Open time picker" },
  nb_NO: { open: "Åpne tidsvelger" },
} as const;
